import React from 'react';
import { ICompanyUser } from '@sharedInterfaces/ICompanySettings';
import './EmployeeSelect.css';
import { generateFullName } from '@sharedInterfaces/globalHelper';
import { ISmallEmployee } from '@sharedInterfaces/IWhoIAm';

function isCompanyUser(employee: ICompanyUser | ISmallEmployee): employee is ICompanyUser
{
    return (employee as ICompanyUser).firstname !== undefined;
}
interface EmployeeSelectProps
{
    employees: ICompanyUser[] | ISmallEmployee[]
    selectedEmployee?: number
    setSelectedEmployee: (val: number | undefined) => void
}
/**
 * EmployeeSelect component.
 * 
 * @param {Object} props - The props for the EmployeeSelect component.
 * @param {EmployeeSelectProps} props - The props for the EmployeeSelect component.
 * @returns {JSX.Element} - The rendered EmployeeSelect component.
 */
function EmployeeSelect({ employees, selectedEmployee, setSelectedEmployee }: EmployeeSelectProps)
{
    const sortedEmployees = [...employees].sort((a, b) =>
    {
        if (isCompanyUser(a) && isCompanyUser(b))
        {
            const compareLastname = a.lastname.localeCompare(b.lastname);
            if (compareLastname !== 0)
            {
                return compareLastname;
            }
            return a.firstname.localeCompare(b.firstname);
        } else if (!isCompanyUser(a) && !isCompanyUser(b))
        {
            return a.title.localeCompare(b.title);
        }
        return 0;
    });
    return (
        <div className="emplyeeSelect">
            <select
                value={selectedEmployee}
                onChange={(e) =>
                {
                    setSelectedEmployee(parseInt(e.target.value))
                }}
            >
                {(
                    selectedEmployee === 0
                    || selectedEmployee === undefined
                ) && <option value={0}></option>}

                {sortedEmployees.map(e =>
                {
                    const fullName = isCompanyUser(e)
                        ? generateFullName(e.firstname, e.lastname)
                        : `${e.title}`; // Adjust as needed for ISmallEmployee

                    return (
                        <option key={e.id} value={e.id}>
                            {fullName}
                        </option>
                    );
                })}
            </select>
        </div>
    );
}

export default EmployeeSelect;


